import React from 'react'
import styled from 'styled-components'
import { Button, useWalletModal } from 'toonswap-uikit'
import useAuth from 'hooks/useAuth'
import { useTranslation } from 'contexts/Localization'

const StyledUnlockButton = styled(Button)`
  background: #fe7b2a !important;
  color: #ffffff !important;
  border: 2px solid #2b3335;
  font-weight: 600;
  border-radius: 12px;

  &:hover:not(:disabled) {
    opacity: 0.9;
    background: #fe7b2a !important;
  }
  &:disabled {
    opacity: 0.5;
  }
`

const UnlockButton = (props) => {
  const { t } = useTranslation()
  const { login, logout } = useAuth()
  const { onPresentConnectModal } = useWalletModal(login, logout)

  return (
    <StyledUnlockButton onClick={onPresentConnectModal} {...props}>
      {t('Unlock Wallet')}
    </StyledUnlockButton>
  )
}

export default UnlockButton
